import { View } from 'tamagui'
import { useState } from 'react'
import { QuestionCard } from './QuestionCard'
import { AssociativeQuestion } from './AssociativeQuestion'
import { TrueFalseQuestion } from './TrueFalseQuestion'
import { MultipleChoiceQuestion } from './MultipleChoiceQuestion'

export function QuestionExamples() {
  const [associativeAnswers, setAssociativeAnswers] = useState<
    Record<number, string>
  >({})
  const [trueFalseAnswer, setTrueFalseAnswer] = useState<string | undefined>()
  const [multipleChoiceAnswer, setMultipleChoiceAnswer] = useState<
    string | undefined
  >()

  const handleAssociativeSelect = (id: number, value: string) => {
    setAssociativeAnswers((prev) => ({
      ...prev,
      [id]: value,
    }))
  }

  const associativePairs = [
    {
      id: 1,
      statement: 'Descrição da sentença a ser associada 1',
      answer:
        'Descrição da resposta a ser associadaDescrição da resposta a ser associada 1',
    },
    {
      id: 2,
      statement: 'Descrição da sentença a ser associada 2',
      answer:
        'Descrição da resposta a ser associadaDescrição da resposta a ser associada 2',
    },
    {
      id: 3,
      statement: 'Descrição da sentença a ser associada 3',
      answer: 'Descrição da resposta 3',
    },
  ]

  const multipleChoiceOptions = [
    {
      id: '1',
      text: 'Descrição de uma das alternativas de resposta dadda Descrição de uma das alternativas de resposta',
    },
    { id: '2', text: 'Descrição de uma das alternativas de resposta' },
    { id: '3', text: 'Descrição de uma das alternativas de resposta' },
    { id: '4', text: 'Descrição de uma das alternativas de resposta' },
  ]

  return (
    <View gap="$spacing-inset-lg">
      <QuestionCard
        questionNumber={1}
        title="Exemplo de enunciado de questão do tipo associativa"
        value={30}
      >
        <AssociativeQuestion
          pairs={associativePairs.map((pair) => ({
            ...pair,
            selectedOption: associativeAnswers[pair.id],
          }))}
          onSelect={handleAssociativeSelect}
        />
      </QuestionCard>

      <QuestionCard
        questionNumber={2}
        title="Exemplo de enunciado de questão do tipo verdadeiro ou falso"
        value={30}
      >
        <TrueFalseQuestion
          statement=""
          selectedValue={trueFalseAnswer}
          onSelect={setTrueFalseAnswer}
        />
      </QuestionCard>

      <QuestionCard
        questionNumber={3}
        title="Exemplo de enunciado de questão do tipo múltipla escolha"
        value={30}
      >
        <MultipleChoiceQuestion
          options={multipleChoiceOptions}
          selectedValue={multipleChoiceAnswer}
          onSelect={setMultipleChoiceAnswer}
        />
      </QuestionCard>
    </View>
  )
}
